var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeclose(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3535_36235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.228 12.5214L4.94066 12.1761L5.46533 10.2167C4.67998 9.92709 3.95008 9.50498 3.30733 8.96874L1.872 10.4047L0.928663 9.46141L2.36466 8.02607C1.55405 7.05524 1.00939 5.89058 0.783997 4.64607L2.096 4.40674C2.602 7.20807 5.05266 9.33341 8 9.33341C10.9467 9.33341 13.398 7.20807 13.904 4.40674L15.216 4.6454C14.9909 5.89008 14.4465 7.05498 13.636 8.02607L15.0713 9.46141L14.128 10.4047L12.6927 8.96874C12.0499 9.50498 11.32 9.92709 10.5347 10.2167L11.0593 12.1767L9.772 12.5214L9.24666 10.5614C8.42157 10.7028 7.57843 10.7028 6.75333 10.5614L6.228 12.5214Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3535_36235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclose);
export default __webpack_public_path__ + "static/media/eyeclose.f20a0bbba2e74e2963f990121ec03ee2.svg";
export { ForwardRef as ReactComponent };